<h1 class="dialog-header" mat-dialog-title anessaTranslation="PROJECT.COMMON.NAME"></h1>
<div class="content-wrapper" mat-dialog-content>
  <p>{{((instruction) ? instruction : 'what name should the structure have?') | anessaTranslation: trigger }}</p>
  <form #f="ngForm">
    <mat-form-field>
      <input
        id="report-name-save_input"
        matInput
        name="txtName"
        [(ngModel)]="data.name"
        required>
    </mat-form-field>
    <div>
      <button
        id="report-name-save_button"
        mat-button
        type="submit"
        (click)="onSaveClick()"
        [disabled]="!f.valid"
        anessaTranslation="PROJECT.COMMON.OK">
      </button>
      <button
        id="report-name-cancel_button"
        mat-button
        type="button"
        (click)="onCancelClick()"
        anessaTranslation="PROJECT.COMMON.CANCEL">
      </button>
    </div>
  </form>
</div>
